import React, { Component } from 'react';
import {
  Container,
  Grid,
  Paper,
  CircularProgress,
  Snackbar
} from '@material-ui/core';
import ProductGridList from '../components/Closet/ProductGridList';
import ProductFilters from '../components/Closet/ProductFilters';
import CartIcon from '../components/Closet/CartIcon';
import CartModal from '../components/Closet/CartModal';
import RequestItemsModal from '../components/Closet/RequestItemsModal';
import CartWarnings from '../components/Closet/CartWarnings';
import '../assets/stylesheets/Closet.css';
import i18n from '../i18n';
import RequireFeatureFlag from '../components/RequireFeatureFlag';
import { getClosetProducts } from '../helpers/externalRequests';

class ClosetView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      products: [],
      productSizeCall: 50,
      productsLoaded: [],
      snackbarOpen: false,
      snackbarMessage: '',
      filters: [],
      appliedFilters: {},
      pagination: {},
      showCart: false,
      showRequestModal: false
    }
  }

  componentDidMount() {
    this.getAndSetProductStates();
  }

  updateSelectedFilters = (selectedFilters) => {
    this.setState({ productsLoaded: [], appliedFilters: selectedFilters }, () => { this.getAndSetProductStates() });
  };

  // eslint-disable-next-line react/destructuring-assignment
  toggleCart = (showCart = !this.state.showCart) => {
    this.setState({ showCart });
  };

  // eslint-disable-next-line react/destructuring-assignment
  toggleRequestModal = (showRequestModal = !this.state.showRequestModal) => {
    this.setState({ showRequestModal });
  };

  getAndSetProductStates = (pageInputted) => {
    const { productSizeCall, appliedFilters } = this.state;
    let page = 1;
    if (pageInputted) {
      page = pageInputted
    }
    appliedFilters.page = page;
    appliedFilters.size = productSizeCall;
    return (this.getProducts(appliedFilters))
      .then(result => {
        this.setState({ ...result.data, loaded: true }, () => { this.addProducts(); });
      })
      .catch(() => {
        this.openSnackbar(i18n.t('productListing:connectionFailed'));
      })
  };

  addProducts = () => {
    this.setState((prevState) => (
      { productsLoaded: prevState.productsLoaded.concat(prevState.products) })
    )
  };

  getProducts = (appliedFilters) => {
    return getClosetProducts(appliedFilters);
  };

  openSnackbar = message => {
    this.setState({ snackbarMessage: message, snackbarOpen: true });
  };

  closeSnackbar = () => {
    this.setState({ snackbarOpen: false, snackbarMessage: '' });
  };

  render() {
    const {
      loaded,
      productsLoaded,
      snackbarMessage,
      snackbarOpen,
      filters,
      pagination,
      showCart,
      showRequestModal
    } = this.state;
    if (!loaded) {
      return (
        <CircularProgress color="inherit" />
      )
    }
    return (
      <Container>
        <RequireFeatureFlag feature="isClosetCartEnabled">
          <CartIcon toggleCart={this.toggleCart} />
          <CartModal
            showModal={showCart}
            onClose={() => this.toggleCart(false)}
            openRequestModal={() => this.toggleRequestModal(true)}
            openSnackbar={this.openSnackbar}
          />
          <RequireFeatureFlag feature="isClosetRequestEnabled">
            <RequestItemsModal
              showModal={showRequestModal}
              onClose={() => this.toggleRequestModal(false)}
            />
          </RequireFeatureFlag>
          <CartWarnings />
        </RequireFeatureFlag>
        <Grid container direction="row">
          <Grid item xs={5} sm={4} md={3}>
            <Grid container direction="column">
              <Grid item xs={12}>
                <ProductFilters
                  updateSelectedFilters={this.updateSelectedFilters}
                  filters={filters}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={7} sm={8} md={9} className="mainGrid">
            <Paper elevation={3} className="root">
              <ProductGridList
                productsLoaded={productsLoaded}
                pagination={pagination}
                getProducts={this.getAndSetProductStates}
                openCart={() => this.toggleCart(true)}
              />
              <Snackbar
                message={snackbarMessage}
                open={snackbarOpen}
                onClose={this.closeSnackbar}
                autoHideDuration={2000}
              />
            </Paper>
          </Grid>
        </Grid>
      </Container>);
  }
}

export default ClosetView;
